import { Typography, Box, Button, styled } from "@mui/material";
import React from "react";

import { Icon } from "../Icon";

const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${(props) => props.theme.spacing(10)} 0;
  > * {
    margin: ${(props) => props.theme.spacing(2)};
  }
`;

interface Props {
  title?: string;
  description?: string;
  refetching: boolean;
  refetch?: () => void;
  onLogout?: () => void;
}

export const ErrorPage = ({ title, description, refetch, refetching, onLogout }: Props) => {
  return (
    <StyledContainer>
      <Icon name="settings" size={100} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="h4">{title || "Une erreur est survenue."}</Typography>

        {description && <Typography sx={{ wordBreak: "break-word" }}>{description}</Typography>}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 250, gap: 2 }}>
        {refetch && (
          <Button loading={refetching} size="large" variant="contained" onClick={refetch}>
            Réessayer
          </Button>
        )}

        {onLogout && (
          <Button size="large" variant="contained" onClick={onLogout}>
            Se déconnecter
          </Button>
        )}
      </Box>
    </StyledContainer>
  );
};
